var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.972 0 0 8.972 0 20V28.286C0 30.334 1.794 32 4 32H6C6.53043 32 7.03914 31.7893 7.41421 31.4142C7.78929 31.0391 8 30.5304 8 30V19.714C8 19.1836 7.78929 18.6749 7.41421 18.2998C7.03914 17.9247 6.53043 17.714 6 17.714H4.184C5.296 9.974 11.956 4 20 4C28.044 4 34.704 9.974 35.816 17.714H34C33.4696 17.714 32.9609 17.9247 32.5858 18.2998C32.2107 18.6749 32 19.1836 32 19.714V32C32 34.206 30.206 36 28 36H24V34H16V40H28C32.412 40 36 36.412 36 32C38.206 32 40 30.334 40 28.286V20C40 8.972 31.028 0 20 0Z",
    fill: "#1F8BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.cb10d85885e6a1a36bdf235b1ce013ea.svg";
export { ForwardRef as ReactComponent };